export default __webpack_public_path__ + "static/media/admin.52578656.jpg";